import { html } from "lit";
import { TeaserNewsroomTemplate as renderNewsroomTeaser } from "../../../partial-templates/teaser/newsroom/teaser-newsroom.templates";
import { TeaserNewsTemplate as renderNewsTeaser } from "../../../partial-templates/teaser/news/teaser-news.templates";
import { dummyNews } from "./mock-data";

const mainTemplate = () => {
    return html`
        <div class="ux-row">
            <div class="ux-col-10 ux-u-offset-1">
                <div class="ux-u-text-align--center">
                    <h2
                        class="ux-text-headline ux-text-headline--big 
                                ux-u-margin-vertical-0 ux-u-margin-m-top-5"
                    >
                        Newsroom
                    </h2>
                </div>
            </div>
        </div>
        <!-- SLIDER -->
        <ux-slider
            effect="slide"
            no-arrows
            breakpoint-s="767"
            breakpoint-m="1023"
            breakpoint-l="1279"
            visible-slides-xl="2"
            visible-slides-l="1"
            visible-slides-m="1"
            visible-slides-s="1"
            space-between-xl="30"
            space-between-l="30"
            space-between-m="30"
            space-between-s="10"
            faded-sides
            slides-auto-height
            slides-overflow-visible
        >
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide class="ux-u-margin-top-25 ux-u-margin-m-top-35">
                ${renderNewsroomTeaser({
                    ...dummyNews[0],
                    inSlider: true,
                })}
            </ux-slider-slide>
            <ux-slider-slide class="ux-u-margin-top-25 ux-u-margin-m-top-35">
                ${renderNewsroomTeaser({
                    ...dummyNews[1],
                    inSlider: true,
                })}
            </ux-slider-slide>
            <ux-slider-slide class="ux-u-margin-top-25 ux-u-margin-m-top-35">
                ${renderNewsroomTeaser({
                    ...dummyNews[2],
                    inSlider: true,
                })}
            </ux-slider-slide>
            <ux-slider-slide class="ux-u-margin-top-25 ux-u-margin-m-top-35">
                ${renderNewsroomTeaser({
                    ...dummyNews[3],
                    inSlider: true,
                })}
            </ux-slider-slide>
            <ux-slider-pagination
                class="ux-u-margin-top-10 ux-u-margin-l-top-15"
                slot="pagination"
                bottom-pagination
            >
            </ux-slider-pagination>
        </ux-slider>
        <!-- END OF THE SLIDER -->
        <div class="ux-iws-newsroom-teaser-slider__cta-container">
            <a class="ux-button" href="#"> Zum Newsroom </a>
            <a
                class="ux-button ux-button--icon-only"
                href="#"
                title="zum News-Archiv"
                aria-label="zum News-Archiv"
                role="button"
            >
                <ux-icon name="tiles"></ux-icon>
            </a>
        </div>
    `;
};

export const NewsroomBlockTemplate = (args) => html`
    <div
        class="ux-iws-newsroom-teaser-slider ux-u-margin-vertical-80 ux-u-margin-l-vertical-100"
    >
        ${args.withInfoTeaser
            ? html` ${mainTemplate()}
                  <div class="ux-row ux-u-margin-top-60">
                      <div class="ux-col-10 ux-u-offset-1">
                          ${renderNewsTeaser({ infoNews: true })}
                      </div>
                  </div>`
            : html`${mainTemplate()}`}
    </div>
`;
